/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitEntityAssetOrderBy = {
    Domain: 'domain',
    IpAddress: 'ip_address',
    Version: 'version',
    AsNumber: 'as_number',
    AsName: 'as_name',
    AsClass: 'as_class',
    Isp: 'isp',
    Shared: 'shared',
    Rdns: 'rdns',
    RdnsParent: 'rdns_parent',
    Created: 'created',
    Updated: 'updated',
    FirstDetected: 'first_detected',
    Source: 'source',
    SourceAsset: 'source_asset',
    CountFindings: 'count_findings',
    MaxLevel: 'max_level'
} as const;
export type MonitEntityAssetOrderBy = typeof MonitEntityAssetOrderBy[keyof typeof MonitEntityAssetOrderBy];


export function MonitEntityAssetOrderByFromJSON(json: any): MonitEntityAssetOrderBy {
    return MonitEntityAssetOrderByFromJSONTyped(json, false);
}

export function MonitEntityAssetOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetOrderBy {
    return json as MonitEntityAssetOrderBy;
}

export function MonitEntityAssetOrderByToJSON(value?: MonitEntityAssetOrderBy | null): any {
    return value as any;
}

